import { useOktaAuth } from '@okta/okta-react';
import UserApi from '../api/UserApi';

interface LogoutReturn {
  logout: () => void;
}

// Utility method to logout the user and revoke their access token with Okta
const Logout = (): LogoutReturn => {
  const { oktaAuth } = useOktaAuth();

  const logout = async () => {
    try {
      UserApi.logout();
    } catch (error) {
      console.error('Logout error: ', error);
    } finally {
      await oktaAuth.signOut();
    }
  };
  return { logout };
};

export default Logout;
